var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgKeyword = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_794_11882)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1851 3.75V1.25H2.18506V7.5H7.81006V18.75H19.6851V3.75H17.1851ZM3.43506 6.25V2.5H15.9351V3.75H7.81006V6.25H3.43506ZM18.4351 17.5H9.06006V5H18.4351V17.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5601 6.875H10.3101V8.125H11.5601V6.875Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1851 6.875H12.8101V8.125H17.1851V6.875Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5601 10.625H10.3101V11.875H11.5601V10.625Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1851 10.625H12.8101V11.875H17.1851V10.625Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5601 14.375H10.3101V15.625H11.5601V14.375Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1851 14.375H12.8101V15.625H17.1851V14.375Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_794_11882"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.935059)"
  })))));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgKeyword);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/keyword.2c71d504af3eeed4ead5840df7070e85.svg";